<template>
    <div class="share-setting-box" v-loading="loading > 0">
      <Header :title="pageTitle"></Header>
      <div class="container">
        <div class="content">
          <!-- <div class="title">协议&政策</div> -->
          <div class="title" v-if="!id">添加</div>
          <el-form
            label-width="110px"
            label-position="right"
            :rules="rules"
            ref="form"
            class="configure-form"
          >
            <el-form-item label="标题" prop="slogan" class="form-item">
              <el-input
                size="small"
                placeholder="请输入标题"
                class="input"
                v-model="title"
                style="width: 270px"
              ></el-input>
              <!-- <el-select
                v-model="way"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
                @change="changeWay"
              >
                <el-option
                  v-for="item in wayList"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                >
                </el-option>
              </el-select> -->
              <!-- <div style="padding-left: 16px;">{{ title }}</div> -->
            </el-form-item>
            <el-form-item label="协议类型" prop="slogan" class="form-item">
              <el-select
                v-model="agreementType"
                placeholder="全部"
                size="small"
                class="input"
                
              >
                <!-- <el-option label="全部" :value="0"></el-option> -->
                <el-option
                  v-for="item in agreement"
                  :key="item.value"
                  :label="item.labelName"
                  :value="+item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="文章内容" prop="slogan" class="form-item">
              <WangEditor
                :text="content"
                class="text"
                :key="way"
                @change="changeText"
              />
            </el-form-item>
          </el-form>
          <!-- <div class="btn-box">
              <button class="btn" @click="handleShare">保存设置</button>
            </div> -->
        </div>
        <div class="btn-box">
          <!-- <button class="cancel-btn" @click="handleCancel">取消</button> -->
          <button class="confirm-btn" @click="handleConfirm">保存设置</button>
        </div>
      </div>
    </div>
  </template>
  
  <script type="text/ecmascript-6">
  import Header from '../../components/common/header';
  import WangEditor from '../../components/common/wang-edit';
  export default {
    components: {
      Header,
      WangEditor
    },
    name: 'share-setting',
    data() {
      return {
        pageTitle: {
          // 页面标题
          firstTitile: '商城设置',
          secondTitle: '用户协议'
        },
        configure: {
          agreement: ''
        },
        agreement: '',
        rules: {},
        loading: 0,
        way: 1,
        title: '',
        userAgreement: '',
        privacyAgreement: '',
        agreement: [],
        agreementMap: {},
        agreementType: null,
        id: null
        // title: ''
      };
    },
    async mounted() {
      this.id = +this.$route.query.id;
      // this.pageTitle.secondTitle = this.title;
      this.id && this.getInfo();
      this.getDictionaryByName("agreement");
    },
    computed: {},
    methods: {
      // 获取分享详情
      getInfo() {
        this.loading++;
        return this.httpGet(this.$root.getAgreementInfo, {
          id: this.id
        }).then(
          (res) => {
            this.loading--;
            this.content = res.content;
            this.title = res.title;
            this.agreementType = res.agreementType;
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      },
      getDictionaryByName(dataName){
        this.loading++;
        this.httpGet(this.$root.getDictionaryByName, {
          dataName
        }).then(
          (res) => {
            this.loading--;
            this[dataName] = res.list;
            let obj = {};
            res.list.forEach(item => {
              obj[item.value] = item.labelName;
            });
            this[dataName + 'Map'] = obj;
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      },
      changeText(val) {
          // 文本更改
          this.content = val;
      },
      // 保存修改
      handleConfirm(){
        this.loading++;
        let url = 'addAgreement';
        let method = 'httpPost';
        let inputData = {
          title: this.title,
          content: this.content,
          agreementType: this.agreementType
        };
        if(this.id){
          url = 'updateAreement';
          method = 'httpPut';
          inputData.id = this.id;
        }
        this[method](this.$root[url], inputData).then(
          (res) => {
            this.loading--;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            // this.getInfo();
            this.$router.back();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      }
    }
  };
  </script>
  <style lang="stylus" rel="stylesheet/stylus">
  @import '~assets/public.styl';
  </style>
  <style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '~assets/main.styl';
  
  .share-setting-box {
    height: 100%;
    width: 100%;
    flex-y(flex-start, flex-start);
    overflow-y: hidden;
    background: bg-color;
  
    .container {
      box-sizing: border-box;
      height: 100%;
      width: 100%;
      overflow-y: auto;
      flex-y(flex-start, flex-start);
      padding: 0 20px 20px;
  
      // content 表格
      .content {
        flex: 1;
        width: 100%;
        font-size: 14px;
        background: white;
        box-sizing: border-box;
        padding: 24px;
        border-radius: 2px;
  
        .title {
          word(20px, #404157);
          font-weight: 550;
        }
  
        .configure-form {
          margin: 50px 80px 0;
  
          .input {
            width: 150px;
          }
        }
  
        .tip {
          word(15, #EA0000);
          margin-top: 24px;
          margin-left: 80px;
        }
  
        .btn-box {
          .btn {
            confirm-btn();
            width: 145px;
            height: 32px;
            margin-top: 24px;
            margin-left: 190px;
          }
        }
  
        .addImg {
          .tips {
            // margin-bottom: 12px;
            line-height: 40px;
          }
  
          .icon {
            width: 240px;
            height: 384px;
          }
  
          .img {
            width: 240px;
            height: auto;
          }
  
          p {
            margin: 0;
          }
  
          .tip {
            color: gray9;
          }
        }
      }
    }
    .btn-box {
      background: white;
      width: 100%;
      flex-x(center);
      padding-bottom: 48px;
  
      .cancel-btn {
        width: 96px;
        height: 40px;
        cancel-btn();
        // border-radius: 23px;
      }
  
      .confirm-btn {
        width: 96px;
        height: 40px;
        margin-left: 20px;
        confirm-btn();
      }
    }
  }
  </style>
  